<template>
	<div @click="itemClick">
		<Menu id="contexHeaderType" mode="horizontal" theme="light" @on-select="itemClick">
			<Submenu id="menu" v-for="(item, index) in blockmenus" :name="item.blockId" :key="index">
				<template slot="title">
					<Icon :type="item.icoName" />
					{{item.blockName}}
				</template>
				<MenuItem v-for="(smallitem, index) in item.child" :name="smallitem.blockId" :key="index"   >  
				{{smallitem.blockName}}
				</MenuItem>
			</Submenu>
		</Menu>
	</div>
</template>

<script>
	import {
		getBlockMenu
	} from '@/network/index.js';


	export default {
		name: "BlockMenu",
		props: {

		},
		data() {
			return {
				blockmenus: []
			}
		},
		created() {
			getBlockMenu().then(res => {
					for (var i = 0; i < res.data.obj.dataList.length; i++) {
						this.blockmenus.push({
							blockId: res.data.obj.dataList[i].blockId,
							blockName: res.data.obj.dataList[i].blockName,
							icoName: res.data.obj.dataList[i].ico,
							child: res.data.obj.dataList[i].child
						})
					}
				})
				.catch(error => {});
		},
		computed: {

		},
		methods: {
			//点击大菜单的事件
			itemClick(name) {
 
				//this.$Message.info('------name----' + name);
				
				this.$router.push({
					path : '/',
					query: {
						//前面的searchValue可以随便取
						blockId: name,
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	#contexHeaderType {
		display: flex; //水平分布
		background-color: #ffffff; //背景色
		position: relative;
		height: 60px;

	}

	#menu {
		flex: 1; //等分
		text-align: center; //等分后居中 

	}
</style>
